import { render, staticRenderFns } from "./customer-promotion-list.vue?vue&type=template&id=41d18df7&scoped=true"
import script from "./customer-promotion-list.vue?vue&type=script&lang=js"
export * from "./customer-promotion-list.vue?vue&type=script&lang=js"
import style0 from "./customer-promotion-list.vue?vue&type=style&index=0&id=41d18df7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d18df7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d18df7')) {
      api.createRecord('41d18df7', component.options)
    } else {
      api.reload('41d18df7', component.options)
    }
    module.hot.accept("./customer-promotion-list.vue?vue&type=template&id=41d18df7&scoped=true", function () {
      api.rerender('41d18df7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/seedFarm-management/promotion-list/customer-promotion-list.vue"
export default component.exports